import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["Component"];
import React, { useEffect } from 'react';
import { OffscreenWatcher } from './OffscreenWatcher';

// The rive module is kinda hefty and is only used in a few places.
// This component dynamically imports it to avoid bloating the main bundle.
var RiveLoader = function RiveLoader(_ref) {
  var Component = _ref.Component,
    props = _objectWithoutProperties(_ref, _excluded);
  var _React$useState = React.useState(null),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    riveModule = _React$useState2[0],
    setRiveModule = _React$useState2[1];
  useEffect(function () {
    var cancelled = false;
    import('@rive-app/react-webgl2').then(function (mod) {
      if (cancelled) return;
      setRiveModule(mod);
    });
    return function () {
      cancelled = true;
    };
  }, []);
  if (!riveModule) {
    return null;
  }
  return /*#__PURE__*/React.createElement(Component, _extends({
    riveModule: riveModule
  }, props));
};
var RivePlayer = function RivePlayer(_ref2) {
  var riveModule = _ref2.riveModule,
    riveUrl = _ref2.riveUrl,
    _ref2$restartOnScroll = _ref2.restartOnScroll,
    restartOnScroll = _ref2$restartOnScroll === void 0 ? true : _ref2$restartOnScroll;
  var useRive = riveModule.useRive;
  var _useRive = useRive({
      src: riveUrl
    }),
    RiveComponent = _useRive.RiveComponent,
    rive = _useRive.rive;
  var _React$useState3 = React.useState(false),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    onScreen = _React$useState4[0],
    setOnScreen = _React$useState4[1];
  useEffect(function () {
    if (!rive) return;
    var _rive$stateMachineNam = _slicedToArray(rive.stateMachineNames, 1),
      firstState = _rive$stateMachineNam[0];
    if (onScreen || !restartOnScroll) {
      rive.play(firstState);
    } else {
      rive.reset();
      rive.play(firstState); // reset to frame 0
      setTimeout(function () {
        return rive.pause();
      }, 1); // pause after a tiny delay to ensure frame 0 is shown
    }
  }, [rive, onScreen, restartOnScroll]);

  // Workaround for bug (WEB-15013) where the animation blanks out on window zoom/resize
  useEffect(function () {
    var abort = new AbortController();
    window.addEventListener('resize', function () {
      if (!rive) return;
      if (rive.playingAnimationNames.length) {
        // animation still playing, bug doesn't occur in this case
        return;
      }

      // For now, just restart the animation
      rive.reset();
      rive.play();
    }, {
      signal: abort.signal
    });
    return function () {
      return abort.abort();
    };
  }, [rive]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, restartOnScroll && /*#__PURE__*/React.createElement(OffscreenWatcher, {
    onScreenChange: setOnScreen
  }), /*#__PURE__*/React.createElement(RiveComponent, null));
};
export var RiveEmbed = function RiveEmbed(_ref3) {
  var riveUrl = _ref3.riveUrl,
    restartOnScroll = _ref3.restartOnScroll;
  return /*#__PURE__*/React.createElement(RiveLoader, {
    Component: RivePlayer,
    riveUrl: riveUrl,
    restartOnScroll: restartOnScroll
  });
};